<template>
  <v-layout
    v-if="!$apollo.loading && whitelabelStats" 
    wrap
  >
    <v-flex
      xs12
    >
      <template>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" />
                <th class="text-left">
                  {{ $t('traderdashboard.today') }}
                </th>
                <th class="text-left">
                  {{ $t('traderdashboard.thisMonth') }}
                </th>
                <th class="text-left">
                  {{ $t('traderdashboard.total') }}
                </th>
              </tr>
            </thead>
            <tbody class="text-no-wrap">
              <tr>
                <td>{{ $t('traderdashboard.revenue') }}</td>
                <td><b>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue.today }}</b></td>
                <td><b>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue.this_month }}</b></td>
                <td><b>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue.total }}</b></td>
              </tr>
              <tr>
                <td>{{ $t('traderdashboard.revenueSubscription') }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue_subscription.today }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue_subscription.this_month }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue_subscription.total }}</td>
              </tr>
              <tr>
                <td>{{ $t('traderdashboard.salesCommission') }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.sales_commission.today }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.sales_commission.this_month }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.sales_commission.total }}</td>
              </tr>
              <!-- <tr v-if="spread">
                <td>{{ $t('traderdashboard.incomeSpread') }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.spread_revenue.today }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.spread_revenue.this_month }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.spread_revenue.total }}</td>
              </tr> -->
              <tr v-if="spread">
                <td>{{ $t('traderdashboard.feeSpread') }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.spread_commission.today }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.spread_commission.this_month }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.spread_commission.total }}</td>
              </tr>
              <tr>
                <td>{{ $t('traderdashboard.users') }}</td>
                <td>{{ whitelabelStats.users.today }}</td>
                <td>{{ whitelabelStats.users.this_month }}</td>
                <td>{{ whitelabelStats.users.total }}</td>
              </tr>
              <tr v-if="deals">
                <td>{{ $t('traderdashboard.potentialDeals') }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.amount_potential_deals.today }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.amount_potential_deals.this_month }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.amount_potential_deals.total }}</td>
              </tr>
              <tr v-if="deals">
                <td>{{ $t('traderdashboard.turnoverDeals') }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.deals_turnover.today }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.deals_turnover.this_month }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.deals_turnover.total }}</td>
              </tr>
              <tr v-if="deals">
                <td>{{ $t('traderdashboard.feeDeals') }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.deals_commissions.today }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.deals_commissions.this_month }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.deals_commissions.total }}</td>
              </tr>
              <tr v-if="deals">
                <td>{{ $t('traderdashboard.quantityLeads') }}</td>
                <td>{{ whitelabelStats.leads_total.today }}</td>
                <td>{{ whitelabelStats.leads_total.this_month }}</td>
                <td>{{ whitelabelStats.leads_total.total }}</td>
              </tr>
              <tr v-if="deals">
                <td>{{ $t('traderdashboard.quantityDeals') }}</td>
                <td>{{ whitelabelStats.deals_total.today }}</td>
                <td>{{ whitelabelStats.deals_total.this_month }}</td>
                <td>{{ whitelabelStats.deals_total.total }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'StatsTable',
  props: {
    whitelabelStats: {
      type: Object,
      default: null
    },
    whitelabelModules: {
      type: Array,
      default: null
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    deals() {
      if (!this.whitelabelModules || this.whitelabelModules.length == 0) {
        return false
      }
      return this.whitelabelModules.some(item => item.module === "realestatedeals");
    },
    spread() {
      if (!this.whitelabelModules || this.whitelabelModules.length == 0) {
        return false
      }
      return this.whitelabelModules.some(item => (item.module === "bulkpayouts" || item.module === "forexspreadpayout"));
    },
  },
}
</script>